import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import ManageFansHeader from './manage-fans-header';
// import ManageFansList from './manage-fans-list';

import TableComponent from 'common/components/table-component';
import { SelectColumnFilter,  NumberRangeColumnFilter, calcTimeSince } from 'common/components/table-component/table-component';

@inject('userStore')
class ManageFans extends React.Component {

	state = {
		searchTerm: ''
	}

	render () {
		const { userStore } = this.props;
		const userList = userStore.subscriberList;
		const tableCols = [
			{
			id: 'userTable',
			columns: [
				{
					Header: 'userID',
					accessor: '_id',
					sortType: 'alphanumeric',
				},
				{
					Header: 'Username',
					accessor: 'userName',
					sortType: 'alphanumeric',
					Cell: ({value, row}) => { return <a href={`/admin/#/user/info/${row.values["_id"]}`}>{value}</a>  },
				},
				{
					Header: 'First Name',
					accessor: 'firstName',
					sortType: 'alphanumeric',
				},
				{
					Header: 'Last Name',
					accessor: 'lastName',
					sortType: 'alphanumeric',
				},
				{
					Header: 'Email',
					accessor: 'email',
					sortType: 'basic'
				},
				{
					Header: 'Age',
					accessor: (f) => { return calcTimeSince(f.dob, { verbose:false, timeType:'YEARS' })},
					sortType: 'basic',
					Filter: NumberRangeColumnFilter,
					filter: 'between',
				},
				{
					Header: '# Subs',
					accessor: 'subscribedTo.length',
					sortType: 'basic',
					Filter: NumberRangeColumnFilter,
					filter: 'between',
				},
				{
					Header: 'Join Date',
					accessor: (f) => { return moment(f.createdAt).format('YYYY-MM-DD') + ` (${calcTimeSince(f.createdAt)})` },
					sortType: 'basic',
				},
			],
			},
		];

		return (
			<div className="grid-x">
				<div className="cell small-12">
					<ManageFansHeader 
						searchTerm={ this.state.searchTerm }
						searchChange={ this.searchChange }
						clearFunc={ this.clearSearch }
					/>
				</div>

				<div className="cell small-12">
				<TableComponent
						tableCols={ tableCols }
						data={ userList }
						initialState={{
							pageIndex: 0,
							sortBy: [
							  {
								id: "name",
								desc: false
							  }
							],
							hiddenColumns: ["_id"],
							filtersVisible: true,
						}}
						//   getHeaderProps={column => ({
						// 	onClick: () => alert('Header!'),
						//   })}
						//   getColumnProps={column => ({
						// 	onClick: () => alert('Column!'),
						//   })}
						//   getRowProps={row => ({
						// 	style: {
						// 	  background: row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
						// 	},
						//   })}
						//   getCellProps={cellInfo => ({
						// 	style: {
						// 	  backgroundColor: `hsl(${120 * ((120 - cellInfo.value) / 120) * -1 +
						// 		120}, 100%, 67%)`,
						// 	},
						//   })}
					/>

					{/* <ManageFansList 
						searchTerm={ this.state.searchTerm }
						searchChange={ this.searchChange }
						meetsFilter={ this.meetsFilter }
					/> */}
				</div>
			</div>
		);
	}

	@autobind
	searchChange2 ({ target }) {
		// this.applyFilter(target.value, "artistList");
		this.applyFilter(this.state.searchTerm, "fanList");
	}
	
	//TODO: Use this filtering solution instead
	@autobind
	searchChange3 ({ target: { value } }) {
		const { artistStore, songsStore, albumsStore } = this.props;

		albumsStore.searchTerm = artistStore.searchTerm = songsStore.searchTerm = value;
		artistStore.search();
	}
	
	@autobind
	searchChange (event) {
		// this.applyFilter(target.value, "artistList");
		console.log("onchange: " + event.target.value);
		this.setState({searchTerm: event.target.value});
		
		const list = document.getElementById("fanList").children;
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.children[0].textContent;
			// if (txt.match(RegExp(event.target.value, "ig"))) {
			item.style = meetsFilter(event.target.value, name) ? {visibility: 'visible'} : {visibility: 'collapse', height: '0px !important'};
			// if (this.meetsFilter(event.target.value, txt))
			// 	// console.log(txt);
			// 	item.style = "visibility: visible;";
			// } else {
			// 	// console.warn(txt);
			// 	item.style = "visibility: collapse; height:0px !important;";
			// }
		}
    }

	@autobind
	clearSearch () {
		const { artistStore, songsStore, albumsStore } = this.props;
		albumsStore.searchTerm = artistStore.searchTerm = songsStore.searchTerm = "";
		
	}

	@autobind
	applyFilter(filter, listID) {
		const list = document.getElementById(listID).children;
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.children[0].textContent;
			if (txt.match(RegExp(filter, "ig"))) {
				// console.log(txt);
				item.style = "visibility: visible;";
			} else {
				// console.warn(txt);
				item.style = "visibility: collapse; height:0px !important;";
			}
		}
	}
	
	@autobind
	meetsFilter(filter, txt) {
		if (txt.match(RegExp(filter, "ig"))) {
			return true;
		} else {
			return false;
		}
	}
}

export default ManageFans;
